export function getCurrentCompanyLocationId() {
    const idHolder = document.querySelector('#current-company-location__id');

    if (idHolder) {
        return idHolder.getAttribute('value');
    }
}
